import axios from 'axios';


 export const getFethSize= () =>{
    return axios.get(
      process.env.REACT_APP_API_GLOBAL_URL+`system-settings`
    );
  }
 export const addFethSize= (configData: ConfigurationType) =>{
  console.log( "configData: ",configData )
    return axios.post(
      process.env.REACT_APP_API_GLOBAL_URL+`system-settings`,configData,{}
    );
  }
 export const updateFethSize= (configData: ConfigurationType) =>{
    return axios.put(
      process.env.REACT_APP_API_GLOBAL_URL+`system-settings`,configData,{}
    );
  }

  export const deleteFethSize= (configData: ConfigurationType) =>{
    return axios.delete(
      process.env.REACT_APP_API_GLOBAL_URL+`system-settings`, { data: configData }
    );
  }

  interface ConfigurationType{
    fetch_size:number;
    id:number;
    isChecked:boolean;
  }